import PersonasSection from './PersonasSection';

export default PersonasSection;
